import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import Box from '../box/Box';
import Heading from '../typography/heading/Heading';
import Text from '../typography/text/Text';
import style from './style';

export default class MobileHeader extends Component {
  state = {
    isToggled: false
  }

  toggleMobileMenu = e => {
    this.setState({isToggled: !this.state.isToggled})
  }
  disableMobileMenu = e => {
    if(this.state.isToggled) {
      this.setState({isToggled: false})
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if(!this.state.isToggled) {
      document.documentElement.style.width = "101%";
      setTimeout(()=>{
        document.documentElement.style.width = "100%"; // hack to correct width thing
      },300)
    }
  }
	render({children}, {isToggled}) {
    const mobileMenuClasses = [style.mobileMenu];
    const contentClasses = [style.contentContainer];
    const hamburgerClasses = [style.hamburger];
    const hamburgerContainer = [style.hamburgerContainer];
    const mobileHeaderContainer = [style.mobileHeaderContainer];
    if(isToggled) {
      mobileMenuClasses.push(style.mobileMenuToggled);
      contentClasses.push(style.contentContainerToggled);
      hamburgerClasses.push(style.hamburgerToggled);
      hamburgerContainer.push(style.hamburgerContainerToggled);
      mobileHeaderContainer.push(style.mobileHeaderContainerToggled);
    }
		return (
			<div class={mobileHeaderContainer.join(' ')}>
        <div class={mobileMenuClasses.join(' ')}>
          <nav>
            <Link activeClassName={style.active} href="/" onClick={this.disableMobileMenu}>罗博深首页</Link>
            <Link activeClassName={style.active} href="/about" onClick={this.disableMobileMenu}>谁是罗博深?</Link>
            <Link activeClassName={style.active} href="/#activities" onClick={this.disableMobileMenu}>罗博深在中国</Link>
          </nav>
        </div>
        <div class={hamburgerContainer.join(' ')}>
          <button class={hamburgerClasses.join(' ')} onClick={this.toggleMobileMenu}>
            <div />
            <div />
            <div />
          </button>
        </div>
        <div class={contentClasses.join(' ')} ref={node=>this.content = node}>
          {children}
        </div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/mobile-header/index.js